import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { SiteService } from '../../services/site.service';
import { UserService } from '../../services/user.service';
import { UserGroupService } from '../../services/user-group.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  searchInput:string = '';
  searchToggleBool = false;

  @ViewChild('search', {static: false}) searchBox: ElementRef;

  onKey(event:KeyboardEvent){

    /* to clean this up, you could consider swappable services...*/
    switch(this.dialogData.searchContextString){

      case 'sites':{
        this.siteService.isSearchOn = true;
        setTimeout(() => {
          this.siteService.search(this.searchInput);
          this.siteService.isSearchOn = false;
        }, 1000)

        break;
      }

      case 'users':{
        this.userService.isSearchOn = true;
    
        setTimeout(() => {
          this.userService.search(this.searchInput);
          this.userService.isSearchOn = false;
        }, 1000);

        break;
      }

      case 'groups':{
        this.userGroupService.isSearchOn = true;
    
        setTimeout(() => {
          this.userGroupService.search(this.searchInput);
          this.userGroupService.isSearchOn = false;
        }, 1000);

        break;
      }


    }

  }

  constructor(
          @Inject(MAT_DIALOG_DATA) private dialogData,
          public dialogRef: MatDialogRef<SearchComponent>, 
          private siteService: SiteService, 
          private userService: UserService, 
          private userGroupService: UserGroupService) { }



  ngOnInit() {
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.searchInput = '';
  }


  close() {
    this.ngOnDestroy();
    this.dialogRef.close();
  }

}
